export function createDateTimePickerError(token: string): Error {
   return new Error(
      `DateTimePicker: No provider found for ${token}. You must import the LcsNativeDateTimeModule` +
         ' at your application root or provide your own implementation.'
   );
}
